module.exports = "<div ng-if=\"!vm.pdfUrl\" class=\"pdf-loader\">\n  <i class=\"fa fa-spinner rotating\"></i>\n</div>\n\n<iframe\n  ng-if=\"vm.pdfUrl\"\n  class=\"pdfjs\"\n  ng-src=\"{{'/assets/pdfjs/web/viewer.html?locale=de&file=' + vm.pdfUrl}}\"\n></iframe>\n\n<div ng-if=\"vm.overlay\" class=\"pdf-frame-overlay\">\n  <div class=\"pdf-frame-overlay__modal\" ng-transclude></div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/common/ui/pdfViewer/pdfViewer.html
// module id = 1662
// module chunks = 0